import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeferQueueItemModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeferQueueItemModalContainer" */
      './DeferQueueItemModalContainer'
    ),
  loading: LoadingModal,
});
